
declare var smartech: any;

export class NetcoreService {
	netcoreEventFire(event: string, data: any) {
		var acc_data : any = localStorage.getItem("acc_data")
		var uniqueId = localStorage.getItem("uniqueId")
		var ucccode = localStorage.getItem("ucccode")
		var userid = acc_data?.accTyp === "CO" ? acc_data?.coAccId : acc_data?.eqAccID;
		var email = acc_data?.accs?.eml;
		var mobile = acc_data?.accs?.mobile;
		var FIRST_NAME = acc_data?.accTyp === "CO" ? acc_data?.coAccName?.split(" ")[0] : acc_data?.eqAccName?.split(" ")[0]
		var LAST_NAME = acc_data?.accTyp === "CO" ? acc_data?.coAccName?.split(" ")[1] : acc_data?.eqAccName?.split(" ")[1]


		smartech('contact', 1, {
            'pk^ucc': uniqueId? uniqueId : '',
            'email': email,
            'mobile': mobile
            });
            if(ucccode) {
                data.ucc = ucccode
            }
            smartech('identify', uniqueId? uniqueId : '' );
            smartech('dispatch',event,data);
	}

}
